import React from 'react';

/* Premium line-art icons, one per core tier (1-8).
   Used for pool orbs, package cards, core selectors, etc. */

const Neural = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="5" cy="6" r="1.6" /><circle cx="5" cy="18" r="1.6" />
    <circle cx="12" cy="12" r="2" /><circle cx="19" cy="6" r="1.6" /><circle cx="19" cy="18" r="1.6" />
    <path d="M6.4 6.8 10 11M6.4 17.2 10 13M13.7 11 17.6 6.8M13.7 13 17.6 17.2" />
  </svg>
);
const Database = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <ellipse cx="12" cy="6" rx="7" ry="3" />
    <path d="M5 6v6c0 1.7 3.1 3 7 3s7-1.3 7-3V6" />
    <path d="M5 12v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6" />
  </svg>
);
const Chip = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <rect x="7" y="7" width="10" height="10" rx="2" /><rect x="10" y="10" width="4" height="4" />
    <path d="M9.5 4v3M14.5 4v3M9.5 17v3M14.5 17v3M4 9.5h3M4 14.5h3M17 9.5h3M17 14.5h3" />
  </svg>
);
const Atom = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="1.8" />
    <ellipse cx="12" cy="12" rx="10" ry="4.4" />
    <ellipse cx="12" cy="12" rx="10" ry="4.4" transform="rotate(60 12 12)" />
    <ellipse cx="12" cy="12" rx="10" ry="4.4" transform="rotate(120 12 12)" />
  </svg>
);
const Globe = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3c3 3.2 3 14.8 0 18M12 3c-3 3.2-3 14.8 0 18M5.2 6c4.2 2.2 9.4 2.2 13.6 0M5.2 18c4.2-2.2 9.4-2.2 13.6 0" />
  </svg>
);
const Cube = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z" />
    <path d="M12 3v9M4 7.5l8 4.5 8-4.5" />
  </svg>
);
const Rocket = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3c3 2 5 5.6 5 9.2 0 1.4-.3 2.6-.8 3.8H7.8C7.3 14.8 7 13.6 7 12.2 7 8.6 9 5 12 3z" />
    <circle cx="12" cy="10" r="1.6" />
    <path d="M9 16l-2.5 4 3.2-1.6M15 16l2.5 4-3.2-1.6" />
  </svg>
);
const Bolt = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8z" />
  </svg>
);

const ICONS = [Neural, Database, Chip, Atom, Globe, Cube, Rocket, Bolt];

/* Unique accent color per core tier (1-8) */
export const CORE_COLORS = [
  '#22d3ee', '#34f5c5', '#6366f1', '#a855f7',
  '#ec4899', '#f59e0b', '#fb7185', '#fbbf24',
];

export const CoreIcon = ({ index = 0 }) => {
  const I = ICONS[index] || ICONS[0];
  return <I />;
};

export default CoreIcon;
